import React from 'react';
import { useVerifica } from './VerificaContext';
import VerificaResult from './VerificaResult';

export default function VerificaOverlay() {
  const { job, ready, closeOverlay, clear } = useVerifica();
  if (!job) return null;
  return (
    <div className="m-verifica-modal" onClick={closeOverlay}>
      <div className="box" onClick={(e) => e.stopPropagation()}>
        <div className="sh">
          <h2>Verifica {job.numero}</h2>
          <button className="x" onClick={closeOverlay}>Riduci</button>
        </div>
        <VerificaResult job={job} />
        {ready && <button className="m-btn" onClick={clear} style={{ marginTop: 12, width: '100%' }}>Chiudi</button>}
      </div>
    </div>
  );
}
